import React from 'react';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import './Hero.css';

export default function Hero() {
  return (
    <section id="about" className="hero">
      <div className="hero__bg"></div>
      
      <div className="hero__shape hero__shape--left"></div>
      <div className="hero__shape hero__shape--right"></div>
      
      <div className="hero__container">
        <div className="hero__content">
          <div className="hero__badge">
            Professor & BOS Chairman
          </div>
          
          <h1 className="hero__title">
            No Research<br />
            is Ever Quite<br />
            Complete
          </h1>
          
          <p className="hero__subtitle">
            <strong>Prof. Dr. B. Jagan Mohan Reddy</strong><br/>
            Department of Chemistry, Adikavi Nannaya University<br/>
            Rajahmundry-AP, India-533 296<br/>
            <span style={{ fontSize: '0.95em', color: '#666' }}>(IUPAC-2011 Young Scientist and 2019 A. P. BEST TEACHER AWARDEE)</span>
          </p>
          
          <div className="hero__controls">
            <button className="hero__control-btn"><FaArrowLeft /></button>
            <button className="hero__control-btn"><FaArrowRight /></button>
          </div>
        </div>
      </div>
    </section>
  );
}
